import { Component, computed, input } from '@angular/core';
import { NumberFormatOptions, NumberPipe } from '@progress/kendo-angular-intl';
import { CapitalizePipe, RcSelectableOverflowDirective, SupplierCreditNote, ValueMismatchComponent } from 'shared';
import { TranslateModule } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'rc-supplier-credit-note-totals-and-taxes',
  imports: [
    TranslateModule,
    NumberPipe,
    CapitalizePipe,
    UpperCasePipe,
    RcSelectableOverflowDirective,
    ValueMismatchComponent,
  ],
  templateUrl: './supplier-credit-note-totals-and-taxes.component.html',
  styleUrl: './supplier-credit-note-totals-and-taxes.component.scss',
})
export class SupplierCreditNoteTotalsAndTaxesComponent {
  supplierCreditNote = input.required<SupplierCreditNote | undefined>();

  extraCosts = computed(() => {
    const scn = this.supplierCreditNote();
    return (scn?.customFees ?? 0) + (scn?.transport ?? 0);
  });

  calculatedNetTotal = computed(() => {
    const scn = this.supplierCreditNote();
    return (scn?.netTotalItems ?? 0) + (scn?.netTotalTax ?? 0) + this.extraCosts();
  });

  calculatedTaxBase = computed(() => {
    const scn = this.supplierCreditNote();
    const discountFactor = scn?.isBelgianSupplier ? 1 - (scn?.paymentDiscountPercentage ?? 0) / 100 : 1;
    const base = (scn?.netTotalItems ?? 0) * discountFactor;
    return base + (scn?.netTotalTax ?? 0) + this.extraCosts();
  });

  calculatedTotal = computed(() => {
    const scn = this.supplierCreditNote();
    return (scn?.netTotal ?? 0) + (scn?.vatTotal ?? 0);
  });

  calculatedPaymentDiscount = computed(() => {
    const scn = this.supplierCreditNote();
    return (scn?.netTotalItems ?? 0) * ((scn?.paymentDiscountPercentage ?? 0) / 100);
  });

  decimalFormat: NumberFormatOptions = {
    style: 'decimal',
    maximumFractionDigits: 2,
    useGrouping: true,
    minimumFractionDigits: 2,
  };
}
